"use client"
import { useEffect } from "react";
import { sendPv } from "@/tracks/25217";
import { useParams } from "next/navigation";
export default function DpPvtrackClient () {
    const { sku } = useParams<{sku: string}>()
    useEffect(()=> {
        sendPv.Productdetail_MainPage({mainskuid: sku})
    }, [])
    return null
}